<template>
  <wh-popup
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.cropEndForm"
    @close="hidePopup"
    @open="openPopup"
  >
    <div class="crop-breed">
      {{ initFormData.cropBreed }}
    </div>
    <van-form ref="cropEndForm" label-width="60px" class="crop-end-form" @submit="submitForm">
      <wh-field-time-popup
        v-model="form.endDate"
        class="end-time"
        name="endDate"
        label="结束时间"
        :rules="rules.endDate"
      />
    </van-form>
    <div class="tips">
      {{ initFormData.plantEndText }}结束的批次可在“历史种养品种”中查看
    </div>
  </wh-popup>
</template>

<script>
import { formPopup } from '@/utils/mixins/formPopup'
import api from '@/api'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import { formatTime } from '@/utils/convert/convertTime'
export default {
  name: 'CropEndPopup',
  components: { WhFieldTimePopup, WhPopup },
  mixins: [formPopup],
  data() {
    return {
      form: {
        id: undefined,
        endDate: ''
      },
      rules: {
        endDate: [{ required: true, message: '请选择结束时间' }]
      }
    }
  },
  computed: {
    title() {
      return this.initFormData.plantEndText
    }
  },
  methods: {
    openPopup() {
      this.formDataInit(this.form, {
        ...this.initFormData,
        endDate: formatTime(new Date())
      })
    },
    submitForm() {
      api.finishCropBreed(this.form).then(({ msg }) => {
        this.$toast.success(msg)
        this.hidePopup()
        this.submitFormSuccess()
      })
    }
  }
}
</script>

<style lang='less' scoped>
.crop-breed {
  text-align: center;
  font-size: 16px;
  margin: 50px 0 20px 0;
}
.end-time {
  border: 1px solid #ccc;
  width: 80%;
  margin: 0 auto;
  border-radius: 20px;
}
.tips {
  font-size: 14px;
  color: #535353;
  text-align: center;
  margin-top: 20px;
}
</style>
